import { Filters } from '@funkey/shared/utils';
import { cx } from 'class-variance-authority';
import Image from 'next/image';
import type { ReactNode } from 'react';
import { serialize as SuperJSON_serialize } from 'superjson';
import Title from '~/components/utils/Title';

export function UnderConstruction(props: { className?: string; children?: ReactNode }) {
    return (
        <div className={cx('w-full', props.className)}>
            <Title>🚧 Under construction 🚧</Title>
            {props.children}
        </div>
    );
}

export const DumpJSON: React.FC<{
    json: any;
    sortKeys?: boolean;
    serializer?: 'superjson' | null;
}> = props => {
    const json = (() => {
        if (props.sortKeys !== true) return props.json;
        if (typeof props.json !== 'object' || props.json === null) return props.json;

        const sorted: typeof props.json = {};

        const keys = Object.keys(props.json).sort((a, b) => a.localeCompare(b));

        for (let index = 0; index < keys.length; index++) {
            const k = keys[index]!;

            sorted[k] = props.json[k];
        }

        return sorted;
    })();

    return (
        <pre className="max-w-full overflow-x-scroll">
            {JSON.stringify(
                props.serializer === 'superjson' ? SuperJSON_serialize(json) : json,
                null,
                4,
            )}
        </pre>
    );
};

export class LoremPicsum {
    /** @default 200 */
    public readonly size: number | { width: number; height: number };
    /** @default undefined */
    public readonly id?: number;
    /** @default true */
    public readonly random: boolean = true;

    public readonly url: URL;

    constructor(config: Partial<Pick<LoremPicsum, 'size' | 'id' | 'random' | 'url'>> = {}) {
        this.size = config.size ?? 200;
        this.id = config.id;
        this.random = config.random ?? true;

        const url = new URL(
            [
                'https://picsum.photos',
                this.id !== undefined && `id/${this.id}`,
                typeof this.size === 'number'
                    ? this.size
                    : `${this.size.width}/${this.size.height}`,
            ]
                .filter(Filters.ok)
                .join('/'),
        );

        // prettier-ignore
        if (this.random === true) url.searchParams.set('random', Math.floor(Math.random() * 1000).toString())

        this.url = url;
    }

    get width(): number {
        return typeof this.size === 'number' ? this.size : this.size.width;
    }

    get height(): number {
        return typeof this.size === 'number' ? this.size : this.size.height;
    }

    toImageProps(): React.ComponentProps<typeof Image> {
        const url = this.url.toString();
        return {
            src: url,
            alt: url,
            width: this.width,
            height: this.height,
        };
    }
}
